(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('aiSettings', aiSettingsService);

    function aiSettingsService(sfHttp, config) {

        this.get = function () {

            return sfHttp.get(config.apiUrl + 'settings/ai');
        };

        this.update = function (aiSettings) {

            return sfHttp.put(config.apiUrl + 'settings/ai', aiSettings);
        };

        this.generate = function (options) {

            return sfHttp.post(config.apiUrl + 'settings/ai', options, { noToast: true });
        };
    }
})();
